export default __webpack_public_path__ + "static/media/DanielCortild.9e520ac6.png";